<section class="flex flex-col items-center justify-center h-screen">
    <div class="flex flex-col items-center justify-center w-[450px] text-center">
        <img src="assets/icons/not-found.svg" alt="not found" class="mb-5">
        <h1 class="text-xl font-bold mb-2">This opportunity no longer exists or is unavailable for participation</h1>
        <p class="text-base font-medium mb-5">Let's help you discover your next opportunity</p>
        <button class="text-wh bg-brand-gray_dark rounded py-3 px-6 cursor-pointer mb-2"
            (click)="onBrowseOpportunities()">
            Browse opportunities
        </button>
        <p class="text-xs font-medium text-Gray-800">You will be automatically redirected in {{ countdown() }}s</p>
    </div>
</section>